import axios from 'axios'

const qhDingInstance = axios.create({
  baseURL: 'https://6bba0123257d411e8fc8bbd0b879c946.z3c.jin10.com',
  headers: {
    'x-app-id': 'dMiaEXHX7OKpTAsX',
    'x-version': '1.0'
  },
  withCredentials: true
})

export const getDingMemberInfo = (params) => {
  return qhDingInstance.post('/member/status_bulk', params)
}

const configInstance = axios.create({
  baseURL: '//common-open-api.jin10.com',
  headers: {
    'x-app-id': 'zP6WFH7WKz2vrw4Q',
    'x-version': '1.0.0'
  },
  withCredentials: true
})

export const getRemoteDingShowConfig = () => {
  return configInstance.get('/configuration/getById', {
    params: {
      id: 1495
    }
  })
}



// WEBPACK FOOTER //
// ./src/apis/qh-ding.js